import { SIG } from "../../common/apiUrl/sig/sigUrls";
import { API } from "../../common/model/objectTypes";
import { recycleBinInfo } from "../../utils/apiDescription/sig/recycleBin";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { getRecycleBinResponseBody, recycleBinRequestParameter, sigBaseRequestBody } from "../../utils/sig/apiObject";
import { deleteRecycleBinJsonRequestCurl, recycleBinJsonRequestCurl, restoreRecycleBinJsonRequestCurl } from "../../utils/sig/sampleJsonRequest";
import { getRecycleBinSignaturesJsonResponse } from "../../utils/sig/sampleJsonResponse";

const DeleteRecycleBin: API= {
    name: "Delete Recycle Bin Signature",
    url: `${API_BASE_URL}/${SIG.RECYCLE_BIN.DELETE_RECYCLE_BIN_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: recycleBinInfo.deleteRecycleBin,
    requestBody: sigBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteRecycleBinJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const All: API = {
    name: "Recycle Bin Signatures",
    url: `${API_BASE_URL}/${SIG.RECYCLE_BIN.RECYCLE_BIN_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: recycleBinInfo.recycleBin,
    requestBody: recycleBinRequestParameter,
    responseBody: getRecycleBinResponseBody,
    jsonRequest: recycleBinJsonRequestCurl,
    jsonResponse: getRecycleBinSignaturesJsonResponse,
}

const RestoreRecycleBinSignature: API = {
    name: "Restore Recycle Bin Signature",
    url: `${API_BASE_URL}/${SIG.RECYCLE_BIN.RESTORE_RECYCLE_BIN_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: recycleBinInfo.restoreRecycleBin,
    requestBody: sigBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: restoreRecycleBinJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return All;
        case 'Restore Recycle Bin':
            return RestoreRecycleBinSignature;
        case 'Recycle Bin':
            return DeleteRecycleBin;
    }
}